let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("lfhFX")]).then(() => parcelRequire('6C8aj'));